import { render, staticRenderFns } from "./create-work-area.vue?vue&type=template&id=05045fa9&scoped=true&"
import script from "./create-work-area.vue?vue&type=script&lang=js&"
export * from "./create-work-area.vue?vue&type=script&lang=js&"
import style0 from "./create-work-area.vue?vue&type=style&index=0&id=05045fa9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05045fa9",
  null
  
)

export default component.exports